import { takeLatest, call , put } from 'redux-saga/effects';
import {
  getUserReactionDetailsSuccess, getUserReactionDetailsFail,
} from './userReactionState';
import createCrudService from '../../services/crudservice';
import { doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess 
	} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/recognition-rewards/user-reactions');
const redirectData = {route:'/console/user-reactions', mode: 'list', recordId:0 };
const modelName = 'User Reaction';
const modelId = 'urc_id';

function* doUserReactionCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getUserReactionDetailsSuccess,
        getUserReactionDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		SAVING_MSG);
}

function* doUserReactionUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getUserReactionDetailsSuccess,
        getUserReactionDetailsFail,
		updateRecordSuccess(modelName),
		redirectData, UPDATING_MSG);	
}

function* doUserReactionDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getUserReactionDetailsSuccess,
        getUserReactionDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}


function* userReactionSaga() {
	yield takeLatest('userReaction/doUserReactionCreate', doUserReactionCreate);
	yield takeLatest('userReaction/doUserReactionUpdate', doUserReactionUpdate);
	yield takeLatest('userReaction/doUserReactionDelete', doUserReactionDelete);  
}

export default userReactionSaga;
